import * as React from "react";
import {Button, Header, Modal} from "semantic-ui-react";
import AceEditor from 'react-ace';

import 'brace/ext/searchbox'

export interface CommandJsonModalProps {
    open: boolean
    commandJson: string
    onClose: () => void
}

export function CommandJsonModal(props: React.PropsWithChildren<CommandJsonModalProps>) {

    return <Modal
        title="Command JSON"
        open={props.open}
        onClose={props.onClose}
        show={true}
        size="fullscreen"
    >
        <Header icon='browser' content='Command JSON'/>
        <Modal.Content>
            <AceEditor
                theme="monokai"
                mode='groovy'
                value={props.commandJson}
                readOnly={true}
                placeholder='selected transportOrder'
                width="100%"
                height="800px"
            />

        </Modal.Content>
        <Modal.Actions>
            <Button onClick={props.onClose} primary>Close</Button>
        </Modal.Actions>
    </Modal>
}